import React, { useEffect, useState, useRef } from "react";
import "./styles.css";
import ReactPlayer from "react-player";
import { Camera } from "react-camera-pro";
import { hatchback, videoSteps } from "./data";
//
import DeskTopView from "../Desktopview";
import RotateDeviceScreen from "../components/RotateDeviceScreen";
import baseUrlNew from "../BaseUrl/index"

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import Cardamagepage from "../Cardmagepage"
import { useHistory } from "react-router-dom";
import {
  landscapeShutterToolbarStyle,
  landscapeShutterButtonStyle,
} from "../utils/landscapeShutterStyle";
import FullscreenCapturePrompt from "../components/FullscreenCapturePrompt";
import { enterImmersiveMode } from "../utils/immersiveMode";
import CameraZoomControls from "../components/CameraZoomControls";
import {
  getCameraVideoElement,
  takeZoomedPhoto,
} from "../utils/cameraZoom";
export default ({props,id,close,setdamgecamra}) => {




  const camera = React.useRef(null);
  const captureRootRef = React.useRef(null);
  const [cameraZoom, setCameraZoom] = useState(1);
  const [imgSrc, setImgSrc] = React.useState([]);
  const [playVideo, setplayVideo] = React.useState(false);
  const [seekAmount, setseekAmount] = React.useState(1);
  const [isMobile, setisMobile] = useState(false);
  const [showdamagecolor, setshowdamagecolor] = useState(false);
  const [img, setimg] = useState("");
  const [orientation, setorientation] = useState("portrait");
  const videoPlayer = useRef(null);
  // check
  const [image, setImage] = useState(null);


  let history = useHistory();


  const [sreen, setsreen] = useState(
    window.orientation == 90 ? "landscap" : "portrait"
  );

  const doOnOrientationChange=()=> {
    // console.log("orientation ", window.orientation);
    switch (window.orientation) {
      // case -90:
      case 90:
        setsreen("landscap");

        // console.log("landcap =========>>>>>", window.orientation);
        break;
      default:
        setsreen("portrait");
        // console.log("portrait =========>>>>", window.orientation);

        break;
    }
  }

  window.addEventListener("orientationchange", doOnOrientationChange);






const done_close=()=>{
  // setdamgecamra(false)
close(true)

}
  // const initialCheck = () => {
  //   const angle = window.orientation;
  //   setisMobile(navigator.userAgentData.mobile);
  //   if (angle === 90) {
  //     setorientation("landscape");
  //   } else {
  //     setorientation("portrait");
  //   }
  // };
  // useEffect(initialCheck, []);
  // window.onorientationchange = initialCheck;
  

  //
  //
  const Uploadpic = (data) => {

    // console.log("qqqqqq",data)
    setimg(data)
    setshowdamagecolor(true)

    // history.push({ pathname: "/cardamagepage", state: {data } });
    
  };

  return showdamagecolor?   <Cardamagepage id={id} image={img} close={setshowdamagecolor}/>:(


<>


<div className="container-fluied aaa">
        <BrowserView>

        <DeskTopView/>

        
        </BrowserView>

        <MobileView>
          {sreen == "landscap" ? (
           
    <div
      ref={captureRootRef}
      className="container_ pi-pictures-camera pi-pictures-camera--landscape"
      onTouchStart={() => enterImmersiveMode(captureRootRef.current || document.documentElement)}
      onClick={() => enterImmersiveMode(captureRootRef.current || document.documentElement)}
    >
     <FullscreenCapturePrompt targetRef={captureRootRef} />
     <button  onClick={() => done_close()}   className="retake_btn">Exit</button>
      <div className="camera_main_cont">
        <div className="camera_wrapper">
          <Camera
            facingMode="environment"
            width="100%"
            height="100%"
            ref={camera}
          />
          <div className="video_wrapper">
          <div className="bottom_title_bar flex_center w-100">
                  <div>Take Images of damage on your car. You can Exit if your car do not have any damage.</div>
                </div>
          </div>
          <CameraZoomControls
            rootRef={captureRootRef}
            zoom={cameraZoom}
            onZoomChange={setCameraZoom}
          />
        </div>
     
        <div className="tool_bar pi-capture-toolbar" style={landscapeShutterToolbarStyle}>
         
            <button
              className="round_button flex_center pi-capture-shutter"
              onClick={() =>
                Uploadpic(
                  takeZoomedPhoto(
                    camera,
                    getCameraVideoElement(captureRootRef.current),
                    cameraZoom
                  )
                )
              }
              style={landscapeShutterButtonStyle}
            >
              <div className="round_button_ flex_center" />
            </button>
 
          {/* <button onClick={videoPlayerHandler}>play/pause</button> */}
        </div>
      </div>
     
    </div>
          ) : (
            <RotateDeviceScreen description="Hold your phone horizontally to photograph vehicle damage." />
          )}
        </MobileView>
      </div>





</>











 
  );
};
